import { render, staticRenderFns } from "./lesson-card.vue?vue&type=template&id=2986d11a&"
import script from "./lesson-card.ts?vue&type=script&lang=ts&"
export * from "./lesson-card.ts?vue&type=script&lang=ts&"
import style0 from "./lesson-card.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports